import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/sidebar";
import { Header } from "@/components/layout/header";
import { useAuthUser } from "@/components/providers/auth-context";
import { useProvisioning } from "@/lib/hooks/use-provisioning";
import { ConnectedQuotaBanner } from "@/components/usage";
import { LocationScopedErrorBoundary } from "@/components/providers/route-error-boundary";

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuthUser();
  const { profile } = useProvisioning();

  const userInfo = {
    email: profile?.user.email,
    name: profile?.user.name ?? undefined,
    picture: user?.picture,
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col">
        <Header onMenuClick={() => setSidebarOpen(true)} user={userInfo} />
        <main className="flex-1">
          <div className="px-4 pt-4 lg:px-6">
            <ConnectedQuotaBanner />
          </div>
          <LocationScopedErrorBoundary>
            <Outlet />
          </LocationScopedErrorBoundary>
        </main>
      </div>
    </div>
  );
}
